export default __webpack_public_path__ + "static/media/info_bonus.min.13ec6546.png";